<template>
  <div class="home">
    <div id="banner">
      <TopBanner />
    </div>
    <div class="aboutUs" id="aboutUs"></div>
    <div id="product">
      <ProductList />
    </div>
    <div id="ip">
      <IpList />
    </div>
    <div id="cooperation">
      <Cooperation />
    </div>
    <div id="case">
      <CaseList />
    </div>
    <div id="delivery">
      <Delivery />
    </div>
    <div class="store" id="store"></div>
  </div>
</template>

<script>
import TopBanner from '../components/TopBanner.vue'
import ProductList from '../components/ProductList.vue'
import IpList from '../components/IpList.vue'
import CaseList from '../components/CaseList.vue'
import Cooperation from '../components/Cooperation.vue'
import Delivery from '../components/Delivery.vue'

export default {
  name: 'HomePage',
  components: {
    TopBanner,
    ProductList,
    IpList,
    CaseList,
    Cooperation,
    Delivery
  }
}
</script>

<style scoped>
.home {
  width: 100%;
}

.aboutUs {
  background-image: url(https://cdn.magicmart.vip/website/assets/about.png);
  background-size: 100%;
  background-repeat: no-repeat;
  width: 100%;
  height: 1000px;
}

.store {
  background-image: url(https://cdn.magicmart.vip/website/assets/store.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 100%;
  height: 672px;
}
</style>
